import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

const defaultGridItemProps = {
  columnStartSm: '1',
  columnEndSm: 'span 12',
  columnStartMd: '2',
  columnEndMd: 'span 10',
  columnStartLg: '3',
  columnEndLg: '11',
};

const headerConfigs = {
  H1: { variant: 'one', gridItemProps: defaultGridItemProps },
  H2: {
    variant: 'two',
    gridItemProps: {
      ...defaultGridItemProps,
      columnStartSm: '1',
      columnEndSm: 'span 12',
      columnStartMd: '1',
      columnEndMd: '13',
    },
  },
  H3: { variant: 'three', gridItemProps: defaultGridItemProps },
  H4: { variant: 'four', gridItemProps: defaultGridItemProps },
  H5: { variant: 'five', gridItemProps: defaultGridItemProps },
  H6: { variant: 'six', gridItemProps: defaultGridItemProps },
};

const ComposableHeading = ({ element, ...props }) => {
  if (!element) {
    return null;
  }

  const { variant, gridItemProps } = headerConfigs[element];

  return (
    <GridItem
      {...gridItemProps}
      as={Heading}
      element={element.toLowerCase()}
      variant={variant}
      {...props}
    />
  );
};

ComposableHeading.defaultProps = {
  element: 'H1',
};

ComposableHeading.propTypes = {
  element: PropTypes.string,
};

export default ComposableHeading;
